import script from "./SimpleSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleSelect.vue?vue&type=script&setup=true&lang=js"

import "./SimpleSelect.vue?vue&type=style&index=0&id=ba4c1c2a&lang=css"

const __exports__ = script;

export default __exports__